const slicer = state => state.data.products;

export const selectIsLoading = state => slicer(state).isLoading ?? true;
export const selectIsProductLoading = (state, productId) => selectProduct(state, productId)?.isLoading ?? false;
export const selectNoProductsAvailable = state => !Object.keys(slicer(state)).length;
export const selectProduct = (state, productId) => selectProducts(state)[productId];
export const selectProductIds = state => Object.keys(selectProducts(state));
export const selectProductLists = state => slicer(state);
export const selectProducts = state => slicer(state).onlineshoppinglist ?? {};
